import { FundingType, type IFunding } from '@bytel/leviator';
import { Box, BoxContent, Text, TextLevels, TrilogyColor, TypographyBold } from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';
import { YounitedIcon } from '@components/younited';

type FundingDetailsBoxProps = {
    funding: IFunding;
    shouldShowFinancingText?: boolean;
};

export function FundingDetailsBox({ funding, shouldShowFinancingText = false }: Readonly<FundingDetailsBoxProps>) {
    return (
        <Box radius='md' shadowless>
            <BoxContent backgroundColor={TrilogyColor.NEUTRAL_FADE}>
                {shouldShowFinancingText && (
                    <Text level={TextLevels.TWO} className='is-flex'>
                        *&nbsp;Financement&nbsp;
                        {(funding.type === FundingType.YOUNITED || funding.type === FundingType.SWAPPY) && (
                            <YounitedIcon />
                        )}
                    </Text>
                )}
                <Text level={TextLevels.ONE} marginless>
                    {funding.installments} mensualités de <InlinePrice amount={funding.monthlyAmount} period='mois' />
                </Text>
                <Text level={TextLevels.ONE} marginless typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    Montant total dû&nbsp;: <InlinePrice amount={funding.totalFinancingCost} />
                </Text>
                <Text level={TextLevels.ONE} marginless typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    TAEG fixe&nbsp;: {funding.APR.toString().replace('.', ',')}%
                </Text>
                <Text level={TextLevels.ONE} marginless>
                    Montant financé&nbsp;: <InlinePrice amount={funding.amountToFinance} typo={[]} />
                </Text>
                <Text level={TextLevels.ONE}>
                    Intérêts&nbsp;: <InlinePrice amount={funding.interestAmount} typo={[]} />
                </Text>
                <Text level={TextLevels.ONE} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    Attention&nbsp;! Un crédit coûte de l&apos;argent et doit être remboursé.
                </Text>
            </BoxContent>
        </Box>
    );
}
